import type { CSSProperties } from 'react';
import { themeVar } from '../theme/themeConfig';

const COMPACT_PADDING = '8px';
const PRIMARY_PADDING = '8px 16px';

export const resolveCommandBarAppearance = <T extends string>(
  key: string,
  appearance?: T
): T | 'primary' | 'subtle' =>
  appearance ??
  (key !== 'newFromTemplate' && /^(new|create|add)/i.test(key)
    ? 'primary'
    : 'subtle');

export const commandBarButtonStyle = (appearance: string): CSSProperties =>
  appearance === 'primary'
    ? {
        padding: PRIMARY_PADDING,
        boxShadow: themeVar('button', 'primaryShadow', 'none'),
        minWidth: 'auto',
      }
    : { padding: COMPACT_PADDING, minWidth: 'auto' };
